import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Play, Clock, Video, Calendar } from "lucide-react";

export default function Courses() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/courses").then((r) => setCourses(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-8" data-testid="courses-page">
      <header>
        <div className="eyebrow">Catálogo</div>
        <h1 className="font-display text-3xl md:text-4xl font-extrabold tracking-tight mt-1">Cursos disponíveis</h1>
        <p className="text-slate-600 mt-2 text-sm">Treinamentos em vídeo, ao vivo e trilhas por cargo.</p>
      </header>

      {loading ? (
        <div className="text-slate-500">Carregando…</div>
      ) : courses.length === 0 ? (
        <Card><CardContent className="p-10 text-center text-slate-600">Nenhum curso disponível ainda.</CardContent></Card>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="courses-grid">
          {courses.map((c) => (
            <Card key={c.id} className="border-[var(--unigr-border)] hover:shadow-md transition-shadow">
              <CardContent className="p-0">
                <div className="aspect-video bg-gradient-to-br from-[var(--unigr-navy)] to-slate-700 text-white flex items-center justify-center relative overflow-hidden">
                  {c.type === "online_live" ? <Calendar className="w-12 h-12 opacity-60" /> : <Video className="w-12 h-12 opacity-60" />}
                  {c.published === false && (
                    <Badge variant="secondary" className="absolute top-3 right-3">Rascunho</Badge>
                  )}
                </div>
                <div className="p-5">
                  <Badge variant="outline" className="mb-3 text-[10px]">
                    {c.type === "online_live" ? "Treinamento ao vivo" : "Curso em vídeo"}
                  </Badge>
                  <div className="font-display font-bold text-lg leading-snug">{c.title}</div>
                  <p className="text-sm text-slate-600 mt-2 line-clamp-3">{c.description}</p>
                  <div className="flex items-center justify-between mt-4 text-xs text-slate-500">
                    <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {c.duration_hours || 0}h</span>
                    <span>{(c.modules || []).length} módulo(s)</span>
                  </div>
                  <Link to={`/courses/${c.id}`}>
                    <Button className="btn-navy w-full mt-4" data-testid={`open-course-${c.id}`}>
                      <Play className="w-4 h-4 mr-2" /> Acessar
                    </Button>
                  </Link>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
